const t = (key: string, defaultValue: string): string => {
  try {
    const stored = localStorage.getItem('selected_language_texts');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed && parsed[key] !== undefined && parsed[key] !== null && parsed[key] !== '') {
        return parsed[key];
      }
    }
  } catch (e) {
    console.warn('Erro ao processar tradução no Texts.ts para chave ' + key, e);
  }
  return defaultValue;
}


export const REGISTER           = t('REGISTER', 'Matrícula')
export const TITLE_SYS          = t('TITLE_SYS', 'COPA KNAUF')
export const PROFILE_TYPE       = t('PROFILE_TYPE', 'TIPO DE PERFIL')
export const BRAZIL             = t('BRAZIL', 'Brasil')
export const SEACH_USER         = t('SEACH_USER', 'Procurar Usuário')
export const MATCH_REALIZED     = t('MATCH_REALIZED', 'Jogos Realizados:')
export const MATCH              = t('MATCH', 'JOGO')
export const ACCESS             = t('ACCESS', 'ENTRAR')
export const SAVE_BET           = t('SAVE_BET', 'SALVAR APOSTA')
export const SAVE_RESULT        = t('SAVE_RESULT', 'SALVAR RESULTADO')
export const SAVE               = t('SAVE', 'SALVAR')
export const SCORE              = t('SCORE', 'Pontos nesse Jogo: ')
export const NOT_MATCH          = t('NOT_MATCH', 'Jogo não apurado')

// LOGIN
export const LOGIN              = t('LOGIN', 'FAÇA O LOGIN')
export const LOGIN_PLACE        = t('LOGIN_PLACE', 'Login')
export const PASS_PLACE         = t('PASS_PLACE', 'Senha')
export const PASS_RESET         = t('PASS_RESET', 'Redefina sua senha nesse primeiro acesso')
export const CHECK_REGULAMENT   = t('CHECK_REGULAMENT', 'Confira o regulamento')
export const FORGOT_PASS        = t('FORGOT_PASS', 'Esqueci minha senha')
export const TXT_NEW_PASS       = t('TXT_NEW_PASS', 'Digite sua nova senha')
export const TXT_CONFIRM_NEW    = t('TXT_CONFIRM_NEW', 'Digite a confirmação da nova senha')

// DASH
export const GERAL_RANK         = t('GERAL_RANK', 'Confira o ranking geral')
export const YOUT_POS           = t('YOUT_POS', ', veja sua posição no ranking')
export const RANK               = t('RANK', 'lugar')
export const MATCH_DAY          = t('MATCH_DAY', 'JOGOS DO DIA')
export const STARTED_DAY        = t('STARTED_DAY', '2026-06-11')

// TELA RANKING 
export const LEGEND             = t('LEGEND', 'Legenda')
export const PG                 = t('PG', 'PG - Pontos Gerais')
export const PC                 = t('PC', 'PC - Placar Cheio')
export const PV                 = t('PV', 'PV - Placar Time Vencedor')
export const DG                 = t('DG', 'DG - Diferença de Gols')
export const PP                 = t('PP', 'PP - Placar Time Perdedor')
export const AC                 = t('AC', 'AC - Acerto Time Vencedor')

export const PG_ABR             = t('PG_ABR', 'PG')
export const PC_ABR             = t('PC_ABR', 'PC')
export const PV_ABR             = t('PV_ABR', 'PV')
export const DG_ABR             = t('DG_ABR', 'DG')
export const PP_ABR             = t('PP_ABR', 'PP')
export const AC_ABR             = t('AC_ABR', 'AC')
export const LOAD_MORE          = t('LOAD_MORE', 'Carregar mais...')
export const FILTER_BY_PLANT    = t('FILTER_BY_PLANT', 'Filtrar por planta')

// MINHAS APOSTAS 

export const MY_BETS            = t('MY_BETS', 'MINHAS APOSTAS')

export const FASE_1             = t('FASE_1', 'Fase de Grupos - Etapa 1')
export const FASE_2             = t('FASE_2', 'Fase de Grupos - Etapa 2')
export const FASE_3             = t('FASE_3', 'Fase de Grupos - Etapa 3')
export const SEGUNDA_FASE       = t('SEGUNDA_FASE', 'Segunda Fase (Round of 32)')
export const OCTAVES            = t('OCTAVES', 'Oitavas de Final')
export const QUARTERFINALS      = t('QUARTERFINALS', 'Quartas de Final')
export const SEMIFINAL          = t('SEMIFINAL', 'Semifinal')
export const THIRD_PLACE        = t('THIRD_PLACE', 'Terceiro Lugar')
export const FINAL              = t('FINAL', 'Final')
export const LAST_RESULT_UPDATED= t('LAST_RESULT_UPDATED', 'Última atualização de resultados em')
export const HAS_MATCH_NO_BET   = t('HAS_MATCH_NO_BET', 'Existe Jogo não preenchido')
export const MULTIPLIER         = t('MULTIPLIER', 'MULTIPLICADOR')

// REGULAMENTO
export const REGULAMENT         = t('REGULAMENT', 'Regulamento')

// MEU PERFIL 
export const DEPARTMENT         = t('DEPARTMENT', 'Departamento')

export const ALTER_PASS         = t('ALTER_PASS', 'Alterar senha')
export const NEW_PASS           = t('NEW_PASS', 'Nova senha')
export const CONFIRM_PASS       = t('CONFIRM_PASS', 'Confirmar senha')
export const RESET_PASS         = t('RESET_PASS', 'Redefinir')
export const NAME               = t('NAME', 'Nome')
export const CS                 = t('CS', 'CS')
export const CHANGE_PASS        = t('CHANGE_PASS', 'Alterar senha')
export const MY_PROFILE         = t('MY_PROFILE', 'Meu perfil')
export const PLANT              = t('PLANT', 'Planta')
export const COUNTRY            = t('COUNTRY', 'País')
export const SAVE_COUNTRY       = t('SAVE_COUNTRY', 'Salvar País')

// USUÁRIOS 
export const NEW_USER           = t('NEW_USER', 'Novo usuário')
export const EDIT_USER          = t('EDIT_USER', 'Edição do usuário')
export const REMOVE_USER        = t('REMOVE_USER', 'Remover Usuário')
export const RESET_PASSWORD     = t('RESET_PASSWORD', 'Redefinir senha')
export const NEW                = t('NEW', 'Novo')
export const USER_TYPE          = t('USER_TYPE', 'Tipo Usuário')
export const FIELD              = t('FIELD', 'CAMPO:')
export const FIELDS             = t('FIELDS', 'CAMPOS:')
export const IS_REQUIRED        = t('IS_REQUIRED', 'é obrigatório:')
export const ARE_REQUIRED       = t('ARE_REQUIRED', 'são obrigatórios:')
export const SELECT_PLANT       = t('SELECT_PLANT', 'SELECIONE UMA PLANTA')
export const SELECT_USER_TYPE   = t('SELECT_USER_TYPE', 'SELECIONE TIPO DE USUÁRIO')
export const ADMIN              = t('ADMIN', 'ADMIN')
export const COMUM              = t('COMUM', 'COMUM')

// Lançar resultados 
export const RESULTS            = t('RESULTS', 'Lançar resultados')
export const MATCH_DATE         = t('MATCH_DATE', 'JOGOS DA DATA:')

// Textos Menu 
export const HOME               = t('HOME', 'INÍCIO')

export const RANKING            = t('RANKING', 'Ranking')
export const USERS              = t('USERS', 'Usuários')
export const TRANSLATIONS       = t('TRANSLATIONS', 'TRADUÇÕES')
export const OUT                = t('OUT', 'SAIR')

// ALERTS
export const OK                 = t('OK', 'OK')
export const ATTENTION          = t('ATTENTION', 'ATENÇÃO!')
export const EMPTY_PASS         = t('EMPTY_PASS', 'Campo Senha e Confirmação de senha são obrigatórios!')
export const WRONG_CONFIRM_PASS = t('WRONG_CONFIRM_PASS', 'A confirmação da nova senha está incorreto! Tente novamente"!')
export const CANT_SAME_REG      = t('CANT_SAME_REG', 'Sua senha não pode ser igual ao número de Matrícula!') 
export const WRONG_TRY_AGAIN    = t('WRONG_TRY_AGAIN', 'Ocorreu um erro, tente novamente!') 
export const LOGIN_AND_PASS     = t('LOGIN_AND_PASS', 'Campos Login e senha são obrigatórios!')
export const LOGIN_OR_PASS      = t('LOGIN_OR_PASS', 'Login ou senha Incorretos!')
export const REMOVED            = t('REMOVED', 'Registro removido com sucesso!')
export const CONFIRM_REMOVE_USER= t('CONFIRM_REMOVE_USER', 'Ao remover o usuário ele não poderá mais acessar a plataforma. Deseja Continuar?')
export const TXT_FORGOT_PASS    = t('TXT_FORGOT_PASS', 'SUA SENHA PRECISA SER ALTERADA. FAVOR DIGITE UMA NOVA SENHA PARA OS ACESSOS FUTUROS!')
export const MSG_FORGOT_PASS    = t('MSG_FORGOT_PASS', 'Caso tenha esquecido a senha, entre em contato com o RH local da sua planta ou com o TI.')
export const MIN_CHAR_PASS      = t('MIN_CHAR_PASS', 'Digite uma senha com pelo menos 5 caracteres!')
export const NOT_CAN_EQUAL      = t('NOT_CAN_EQUAL', 'Sua senha não pode ser igual sua Matrícula!')
export const WRONG_CONFIRM      = t('WRONG_CONFIRM', 'A confirmação da senha está incorreta!')

// IDIOMAS & MODAL
export const SELECT_LANGUAGE     = t('SELECT_LANGUAGE', 'Selecione o Idioma / Select Language')
export const LOADING_LANGUAGES   = t('LOADING_LANGUAGES', 'Carregando idiomas...')
export const LANGUAGE            = t('LANGUAGE', 'Idioma / Language')

// BLOCK GAME
export const MAX_NUMBER_ACCEPTED = t('MAX_NUMBER_ACCEPTED', 'Número máximo aceito é  99!')
export const SELECT_TEAM         = t('SELECT_TEAM', 'Selecione um time!')
export const CHANGE_TEAM         = t('CHANGE_TEAM', 'ALTERAÇÃO DE TIME')
export const SELECT_TEAM_FOR_MATCH = t('SELECT_TEAM_FOR_MATCH', 'SELECIONE O TIME QUE DESEJA ALTERAR PARA ESSA PARTIDA!')
export const TEAM                = t('TEAM', 'TIME')
export const CLOSE               = t('CLOSE', 'FECHAR')
export const UNEXPECTED_ERROR    = t('UNEXPECTED_ERROR', 'Ocorreu um erro imprevisto, tente novamente!')

export const P_AC = t('P_AC', 'AC - Acerto apenas do time vencedor  - 10 pontos')
export const P_DG = t('P_DG', 'DG - Acerto da diferença de gols entre o vencedor e o perdedor - 15 pontos')
export const P_PC = t('P_PC', 'PC - Acerto do placar exato da partida - 25 pontos')
export const P_PP = t('P_PP', 'PP - Acerto do placar do time perdedor - 12 pontos')
export const P_PV = t('P_PV', 'PV - Acerto do placar do time vencedor - 18 pontos')

// REGULAMENTO DETALHADO
export const REG_TITLE_1 = t('REG_TITLE_1', '1. CADASTRO')
export const REG_TEXT_1_2 = t('REG_TEXT_1_2', '1.2 A senha dos colaboradores será o número de matrícula, sendo que será obrigatório a alteração após o primeiro login.')
export const REG_TEXT_1_3 = t('REG_TEXT_1_3', '1.3 caso o colaborador esqueça a senha, existirá perfis de administradores que poderão redefinir a mesma, a senha padrão para redefinição será o número da matrícula. Sendo obrigatório a alteração no próximo login.')
export const REG_TEXT_1_4 = t('REG_TEXT_1_4', '1.4 os administradores poderão adicionar e remover usuários ao decorrer do bolão')

export const REG_TITLE_2 = t('REG_TITLE_2', '2. SISTEMA DE PONTUAÇÃO')
export const REG_TEXT_2_1 = t('REG_TEXT_2_1', '2.1 A pontuação dos participantes será feita em função de seus palpites nos times vencedores e placares das partidas.')
export const REG_TEXT_2_2 = t('REG_TEXT_2_2', '2.2 não é obrigatório o colaborador fazer todas as apostas, porém ao não fazer, não receberá a pontuação para aquela partida.')
export const REG_TEXT_2_3 = t('REG_TEXT_2_3', '2.3 Os palpites irão incluir apenas o tempo regulamentar e excluindo a prorrogação e a disputa de pênaltis, quando houver.')
export const REG_TEXT_2_4 = t('REG_TEXT_2_4', '2.4 Cada colaborador poderá alterar os palpites quantas vezes quiser antes de cada partida, 5 minutos antes dos jogos os palpites se encerrarão, não podendo mais alterar o palpite daquele jogo.')
export const REG_TEXT_2_5 = t('REG_TEXT_2_5', '2.5 Os critérios de pontuação são os seguintes:')

export const REG_SUB_WINNER = t('REG_SUB_WINNER', 'Apostando que a partida terá um vencedor')
export const REG_LI_WINNER_1 = t('REG_LI_WINNER_1', 'Acerto do placar exato da partida - 25 pontos. (PC)')
export const REG_LI_WINNER_2 = t('REG_LI_WINNER_2', 'Acerto do placar do time vencedor - 18 pontos. (PV)')
export const REG_LI_WINNER_3 = t('REG_LI_WINNER_3', 'Acerto da diferença de gols entre o vencedor e o perdedor - 15 pontos. (DG)')
export const REG_LI_WINNER_4 = t('REG_LI_WINNER_4', 'Acerto do placar do time perdedor - 12 pontos. (PP)')
export const REG_LI_WINNER_5 = t('REG_LI_WINNER_5', 'Acerto apenas do time vencedor - 10 pontos. (AC)')

export const REG_SUB_DRAW = t('REG_SUB_DRAW', 'Apostando que a partida terminará empatada')
export const REG_LI_DRAW_1 = t('REG_LI_DRAW_1', 'Acerto do placar exato - 25 pontos. (PC)')
export const REG_LI_DRAW_2 = t('REG_LI_DRAW_2', 'Acerto do empate não exato - 15 pontos.')

export const REG_TEXT_MULTIPLIER = t('REG_TEXT_MULTIPLIER', '2.5 O campeonato inicia com o peso dos jogos igual a 10 e a cada dia de jogo o peso aumenta em +1, sendo um multiplicador dos pontos ganhos no dia.')

export const REG_TITLE_3 = t('REG_TITLE_3', '3. CRITÉRIO DE DESEMPATE')
export const REG_TEXT_3_1 = t('REG_TEXT_3_1', '3.1 Serão considerados, para fins de desempate os seguintes critérios, na respectiva ordem:')
export const REG_LI_TIE_1 = t('REG_LI_TIE_1', 'O maior número de acertos de placar em cheio (PC)')
export const REG_LI_TIE_2 = t('REG_LI_TIE_2', 'O maior número de acertos do escore do vencedor (PV)')
export const REG_LI_TIE_3 = t('REG_LI_TIE_3', 'O maior número de acertos da diferença de gols (DG)')
export const REG_LI_TIE_4 = t('REG_LI_TIE_4', 'O maior número de acertos do escore do perdedor (PP)')
export const REG_LI_TIE_5 = t('REG_LI_TIE_5', 'O maior número de acertos do time vencedor (AC)')

export const REG_TITLE_4 = t('REG_TITLE_4', '4. RANKING')
export const REG_TEXT_4_1 = t('REG_TEXT_4_1', '4.1 O ranking será geral, podendo ser filtrado por plantas para melhor identificação.')
export const REG_TEXT_4_2 = t('REG_TEXT_4_2', '4.2 No ranking será mostrado as seguintes informações:')
export const REG_LI_RANK_1 = t('REG_LI_RANK_1', 'Nome + Sobrenome')
export const REG_LI_RANK_2 = t('REG_LI_RANK_2', 'Planta')
export const REG_LI_RANK_3 = t('REG_LI_RANK_3', 'Setor')
export const REG_LI_RANK_4 = t('REG_LI_RANK_4', 'Pontuação Geral')
export const REG_LI_RANK_5 = t('REG_LI_RANK_5', 'Número de acertos de Placar Cheio (PC)')
export const REG_LI_RANK_6 = t('REG_LI_RANK_6', 'Número de acertos de placar do time vencedor (PV)')
export const REG_LI_RANK_7 = t('REG_LI_RANK_7', 'Número de acertos de diferença de gols (DG)')
export const REG_LI_RANK_8 = t('REG_LI_RANK_8', 'Número de acertos de placar do time perdedor (PP)')
export const REG_LI_RANK_9 = t('REG_LI_RANK_9', 'Número de acertos time vencedor (AC)')
export const REG_TEXT_4_3 = t('REG_TEXT_4_3', '4.3 apenas aparecerá no ranking os colaboradores que fizeram o processo de cadastro. (processo descrito na sessão 1)')
export const REG_TEXT_4_4 = t('REG_TEXT_4_4', '4.4 o ranking será atualizado em até 24 horas após o final das partidas, mostrando para o colaborador a data e hora da última atualização dos resultados.')

export const REG_TITLE_5 = t('REG_TITLE_5', '5. PREMIAÇÃO')
export const REG_TEXT_5_1 = t('REG_TEXT_5_1', '5.1 Os prêmios serão para os 10 primeiros colocados do Bolão, sendo')
export const REG_LI_AWARD_10 = t('REG_LI_AWARD_10', '10º Lugar: Camiseta oficial da Copa.')
export const REG_LI_AWARD_9 = t('REG_LI_AWARD_9', '9º Lugar: Camiseta oficial da Copa.')
export const REG_LI_AWARD_8 = t('REG_LI_AWARD_8', '8º Lugar: Camiseta oficial da Copa.')
export const REG_LI_AWARD_7 = t('REG_LI_AWARD_7', '7º Lugar: Camiseta oficial da Copa.')
export const REG_LI_AWARD_6 = t('REG_LI_AWARD_6', '6º Lugar: Amazon Echo Dot (4ª Geração).')
export const REG_LI_AWARD_5 = t('REG_LI_AWARD_5', '5º Lugar: Kit Churrasco Tramontina/ Churrasking.')
export const REG_LI_AWARD_4 = t('REG_LI_AWARD_4', '4º Lugar: Amazon Echo Show 5 (2ª Geração).')
export const REG_LI_AWARD_3 = t('REG_LI_AWARD_3', '3º Lugar: Tablet Samsung A8.')
export const REG_LI_AWARD_2 = t('REG_LI_AWARD_2', '2º Lugar: XBox série S.')
export const REG_LI_AWARD_1 = t('REG_LI_AWARD_1', '1º Lugar: Smart TV 50".')


// GRUPOS
export const GROUPS             = t('GROUPS', 'GRUPOS')
export const NEW_GROUP          = t('NEW_GROUP', 'Novo Grupo')
export const EDIT_GROUP         = t('EDIT_GROUP', 'Editar Grupo')
export const VIEW_GROUP         = t('VIEW_GROUP', 'Visualizar Grupo')
export const GROUP_NAME         = t('GROUP_NAME', 'Nome do Grupo')
export const MEMBERS            = t('MEMBERS', 'Integrantes')
export const ADD_MEMBERS        = t('ADD_MEMBERS', 'Adicionar Integrantes')
export const REMOVE_MEMBER      = t('REMOVE_MEMBER', 'Remover Integrante')
export const CONFIRM_REMOVE_GROUP = t('CONFIRM_REMOVE_GROUP', 'Deseja realmente excluir este grupo?')


export const GO_BACK             = t('GO_BACK', 'VOLTAR')
export const SELECT_YOUR_COUNTRY = t('SELECT_YOUR_COUNTRY', 'Selecione seu país')

// NEW GROUP & RANKING TRANSLATIONS
export const COULD_NOT_LOAD_GROUP_INFO = t('COULD_NOT_LOAD_GROUP_INFO', 'Não foi possível carregar as informações do grupo.')
export const MIN_SEARCH_CHARS          = t('MIN_SEARCH_CHARS', 'Digite pelo menos 2 caracteres para buscar!')
export const CANT_REMOVE_YOURSELF      = t('CANT_REMOVE_YOURSELF', 'Você não pode se remover do seu próprio grupo!')
export const GROUP_NAME_REQUIRED       = t('GROUP_NAME_REQUIRED', 'O nome do grupo é obrigatório!')
export const LOADING                   = t('LOADING', 'Carregando')
export const LOADING_GROUP_INFO        = t('LOADING_GROUP_INFO', 'Carregando informações do grupo...')
export const GROUP_NAME_PLACEHOLDER    = t('GROUP_NAME_PLACEHOLDER', 'Ex: Bora Grupo, Bolão Knauf, etc.')
export const MEMBER_NAME_PLACEHOLDER   = t('MEMBER_NAME_PLACEHOLDER', 'Nome do integrante...')
export const SEARCHING                 = t('SEARCHING', 'Buscando...')
export const SEARCH                    = t('SEARCH', 'BUSCAR')
export const ADD                       = t('ADD', 'Adicionar')
export const NO_PARTICIPANT_FOUND      = t('NO_PARTICIPANT_FOUND', 'Nenhum participante encontrado com este nome.')
export const MEMBER                    = t('MEMBER', 'INTEGRANTE')
export const MATRICULA_UPPER           = t('MATRICULA_UPPER', 'MATRÍCULA')
export const PLANT_UPPER               = t('PLANT_UPPER', 'PLANTA')
export const YOU                       = t('YOU', ' (Você)')
export const NO_MEMBERS_ADDED          = t('NO_MEMBERS_ADDED', 'Nenhum integrante adicionado.')
export const CANCEL                    = t('CANCEL', 'CANCELAR')
export const YES                       = t('YES', 'SIM')
export const LOADING_GROUPS            = t('LOADING_GROUPS', 'Carregando grupos...')
export const ID                        = t('ID', 'ID')
export const GROUP                     = t('GROUP', 'GRUPO')
export const OWNER                     = t('OWNER', 'PROPRIETÁRIO')
export const MEMBERS_UPPER             = t('MEMBERS_UPPER', 'INTEGRANTES')
export const GROUP_SINGULAR            = t('GROUP_SINGULAR', 'Grupo')
export const SYSTEM                    = t('SYSTEM', 'Sistema')
export const DELETE_GROUP              = t('DELETE_GROUP', 'Excluir Grupo')
export const NO_GROUPS_YET             = t('NO_GROUPS_YET', 'Você ainda não faz parte de nenhum grupo. Clique em "Novo Grupo" para criar um!')
export const GENERAL_RANKING           = t('GENERAL_RANKING', 'Ranking Geral')
export const REGISTERS_PER_PAGE         = t('REGISTERS_PER_PAGE', 'Registros por página:')
export const OF                        = t('OF', 'de')

// PAÍSES - Nomes traduzíveis (o admin pode alterar esses textos na tela de Traduções)
export const COUNTRY_FRA = t('COUNTRY_FRA', 'França')
export const COUNTRY_ESP = t('COUNTRY_ESP', 'Espanha')
export const COUNTRY_MAR = t('COUNTRY_MAR', 'Marrocos')
export const COUNTRY_HUN = t('COUNTRY_HUN', 'Hungria')
export const COUNTRY_ITA = t('COUNTRY_ITA', 'Itália')
export const COUNTRY_GER = t('COUNTRY_GER', 'Alemanha')
export const COUNTRY_BRA = t('COUNTRY_BRA', 'Brasil')
export const COUNTRY_POL = t('COUNTRY_POL', 'Polônia')